<template>
  <div class="menu-container" @click="closeMenu()">
    <div class="menu-content-container" @click.prevent.stop="">
      <ul class="menu-items-container">
        <!-- <li><router-link :to="{name: 'About', params: {lang: this.$i18n.locale}}" @click.native="goTo('About')"><AboutUs /></router-link></li>
        <li><router-link :to="{name: 'Proyectos', params: {lang: this.$i18n.locale}}" @click.native="goTo('Works')"><Projects /></router-link></li>
        <li><router-link :to="{name: 'products', params: {lang: this.$i18n.locale}}" @click.native="goTo('Productos')"><Products /></router-link></li>
        <li><router-link :to="{name: 'Materiales', params: {lang: this.$i18n.locale}}" @click.native="goTo('Material')"><Materials /></router-link></li>
        <li><router-link :to="{name: 'DesignInsight', params: {lang: this.$i18n.locale}}" @click.native="goTo('DesignInsight')"><Lab /></router-link></li>
        <li><router-link :to="{name: 'Videos', params: {lang: this.$i18n.locale}}" @click.native="goTo('Videos')"><Videos /></router-link></li>
        <li><router-link :to="{name: 'Contact', params: {lang: this.$i18n.locale}}" @click.native="goTo('Contact')"><Contact /></router-link></li>
        <li><router-link :to="{name: 'Partners', params: {lang: this.$i18n.locale}}" @click.native="goTo('Partners')"><Partners /></router-link></li> -->
        <li v-for="item in menuItems" :key="item.name">
          <router-link
            :to="{ name: item.route, params: { lang: $i18n.locale } }"
            @click.native="goTo(item.route)"
          >
            <component :is="getComponent(item.component)" />
          </router-link>
        </li>
      </ul>
      <div class="langs-container">
        <LangES class="lang-item" :class="{'lang-active': $i18n.locale === 'es'}" @click.native="changeLanguage('es')" />
        <LangEN class="lang-item" :class="{'lang-active': $i18n.locale === 'en'}" @click.native="changeLanguage('en')" />
      </div>
    </div>
    <!-- <HeaderContacts class="contact-icons-container" /> -->
  </div>
</template>

<script>
import { EventBus } from '@/event-bus'
// import HeaderContacts from './header/Contacts'
import { gsap } from 'gsap'
import LangES from './menuSVG/LangES.vue'
import LangEN from './menuSVG/LangEN.vue'

const componentsMap = {
  AboutUs: { es: 'AboutUs', en: 'AboutUsEN' },
  Projects: { es: 'Projects', en: 'ProjectsEN' },
  Products: { es: 'Products', en: 'ProductsEN' },
  Materials: { es: 'Materials', en: 'MaterialsEN' },
  Lab: { es: 'Lab', en: 'LabEN' },
  Videos: { es: 'Videos', en: 'VideosEN' },
  Contact: { es: 'Contact', en: 'ContactEN' },
  Partners: { es: 'Partners', en: 'PartnersEN' }
}

export default {
  components: {
    AboutUs: () => import('./menuSVG/AboutUs.vue'),
    Projects: () => import('./menuSVG/Projects.vue'),
    Products: () => import('./menuSVG/Products.vue'),
    Materials: () => import('./menuSVG/Materials.vue'),
    Lab: () => import('./menuSVG/Lab.vue'),
    Videos: () => import('./menuSVG/Videos.vue'),
    Contact: () => import('./menuSVG/Contact.vue'),
    Partners: () => import('./menuSVG/Partners.vue'),
    AboutUsEN: () => import('./menuSVG/AboutUsEN.vue'),
    ProjectsEN: () => import('./menuSVG/ProjectsEN.vue'),
    ProductsEN: () => import('./menuSVG/ProductsEN.vue'),
    MaterialsEN: () => import('./menuSVG/MaterialsEN.vue'),
    LabEN: () => import('./menuSVG/LabEN.vue'),
    VideosEN: () => import('./menuSVG/VideosEN.vue'),
    ContactEN: () => import('./menuSVG/ContactEN.vue'),
    PartnersEN: () => import('./menuSVG/PartnersEN.vue'),
    LangES,
    LangEN
  },
  data () {
    return {
      menuItems: [
        { name: 'About', route: 'About', component: 'AboutUs' },
        { name: 'Proyectos', route: 'Proyectos', component: 'Projects' },
        { name: 'Productos', route: 'products', component: 'Products' },
        { name: 'Materiales', route: 'Materiales', component: 'Materials' },
        { name: 'Design Insight', route: 'DesignInsight', component: 'Lab' },
        { name: 'Videos', route: 'Videos', component: 'Videos' },
        { name: 'Contacto', route: 'Contact', component: 'Contact' },
        { name: 'Partners', route: 'Partners', component: 'Partners' }
      ]
    }
  },
  methods: {
    initAnimation () {
      const tl = gsap.timeline()

      tl.from('.menu-container', {
        duration: 0.5,
        opacity: 0,
        ease: 'power2.out'
      })
      tl.to('.menu-content-container', {
        duration: 0.5,
        x: 0,
        ease: 'power2.out'
      }, '-=0.5')
      tl.to('.menu-items-container li a', {
        duration: 0.5,
        y: 0,
        ease: 'power2.out',
        stagger: 0.1
      }, '-=0.5')
      tl.from('.contact-icon-menu', {
        duration: 0.5,
        opacity: 0,
        ease: 'power2.out',
        stagger: 0.1
      }, '<')
      tl.to('.lang-item', {
        duration: 0.5,
        y: 0,
        ease: 'power2.out',
        stagger: 0.1
      }, '-=0.5')
    },
    goTo (name) {
      if (name === 'About') {
        window.location.href = '/' + this.$i18n.locale + '/about'
      } else {
        EventBus.$emit('toggleMenu', false)
      }
      // this.$router.push({ name: name })
    },
    getComponent (name) {
      return componentsMap[name][this.$i18n.locale] || componentsMap[name].es
    },
    closeMenu () {
      EventBus.$emit('closeMenu')
    },
    changeLanguage (locale) {
      EventBus.$emit('changeLanguage', locale)
    }
  },
  mounted () {
    EventBus.$emit('bodyScroll', false)

    this.initAnimation()
  }
}
</script>

<style lang="scss" scoped>
.menu-container {
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 100;
  @include backgroundTransparency(#000000, 0.5);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: end;

  .menu-content-container {
    height: 100%;
    width: 50%;
    max-width: 600px;
    transform: translateX(100%);
    @include backgroundTransparency(#000000, 1);

    .menu-items-container {
      margin-top: 120px;
      margin-bottom: 0;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: end;
      padding-right: var(--main-space);
      max-height: calc(100vh - 120px); // resto margin top
      overflow-y: auto;

      li {
        // width: 300px;
        margin-bottom: calc(var(--main-space) / 2 * 1.5);
        display: flex;
        justify-content: end;
        height: fit-content;
        overflow: hidden;

        a {
          transform: translateY(100%);
        }

        &:hover:deep( svg *) {
          fill: #FFF;
        }
        svg{
          height: 100%;
          min-height: 30px;
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    .langs-container {
      display: flex;
      flex-direction: row;
      justify-content: end;
      align-items: center;
      gap: 0 var(--main-space);
      height: calc(var(--main-space) / 2 * 1.5);
      padding-right: var(--main-space);
      margin-top: calc(calc(var(--main-space) / 2 * 1.5)*2);
      overflow: hidden;

      .lang-item {
        height: 100%;
        transform: translateY(100%);
        cursor: pointer;

        &.lang-active {
          :deep(*) {
            fill: #FFF;
          }
        }
      }
    }
  }

  .contact-icons-container {
    position: absolute;
    bottom: var(--main-space);
    right: 0;
    height: var(--main-space);
  }
}

/* @media screen and (min-width: 1600px){
  .menu-container {
    .menu-content-container {
      .menu-items-container {
        li {
          margin-bottom: calc(var(--main-space) / 2 * 1.5);
        }
      }
    }
  }
} */
@include media-breakpoint-down(sm) {
  .menu-container {
    .menu-content-container {
      width: 100%;
      .menu-items-container {
        li{
          margin-bottom: var(--main-space);
          svg{
            min-height: 24px;
          }
        }
      }
    }
    .langs-container {
      margin-top: calc(var(--main-space) * 2) !important;
      height: var(--main-space) !important;
    }
  }
}
</style>
